// Persistence of the selected tenant across page loads (localStorage).
// Pure storage helpers — no React, no API — so both the auth layer and the
// filter hooks can depend on it without pulling each other in.

const STORAGE_KEY = 'stables_tenant_selection';

export const getPersistedTenantId = (multiSelect = false) => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            const tenantId = parsed.tenant_id;
            if (tenantId !== undefined && tenantId !== null && tenantId !== '') {
                if (!multiSelect && typeof tenantId === 'string' && tenantId.includes(',')) {
                    return tenantId.split(',')[0];
                }
                return tenantId;
            }
        }
    } catch (error) {
        console.error('Error reading tenant from localStorage:', error);
    }
    return 0;
};

export const persistTenantId = (tenantId) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ tenant_id: tenantId }));
    } catch (error) {
        console.error('Error saving tenant to localStorage:', error);
    }
};

export const clearPersistedTenantId = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.error('Error clearing tenant from localStorage:', error);
    }
};
